import { useBreakpointValue } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useHotkeys } from 'react-hotkeys-hook';
import { useAtomValue } from 'jotai';
import { MBox } from '../components/Monetize';
import { CommandPalette } from '../components/App/CommandPalette/CommandPalette';
import { useChatPanelWidth } from '../components/Chat/useChatPanelWidth';
import { ROUTES } from '../constants';
import { APP_SIDEBAR_WIDTH } from '../constants/layout';
import { appLayoutState, chatPanelOpenState } from '../store/global.store';
import { AppSidebar } from './AppSidebar';

const App: FC<any> = ({ children }: any) => {
  const layoutMode = useAtomValue(appLayoutState);
  const chatPanelOpen = useAtomValue(chatPanelOpenState);
  const { width: chatPanelWidth } = useChatPanelWidth();
  const isMobileChat = useBreakpointValue({ base: true, lg: false }) ?? false;
  const chatMarginRight = chatPanelOpen && !isMobileChat ? chatPanelWidth : 0;
  const location = useLocation();
  const isSettingsPath = location.pathname === ROUTES.SETTINGS;
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);

  useHotkeys('mod+k', () => setIsPaletteOpen(true), {
    enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    preventDefault: true,
  });

  return (
    <MBox>
      <AppSidebar />

      <MBox
        marginLeft={`${APP_SIDEBAR_WIDTH[layoutMode]}px`}
        marginRight={chatMarginRight}
        transition="margin 0.2s"
        overflowX="clip"
        bgColor={isSettingsPath ? 'tGray.sidebarDark' : undefined}
      >
        {children || <Outlet />}
      </MBox>

      <CommandPalette
        isOpen={isPaletteOpen}
        onClose={() => setIsPaletteOpen(false)}
      />
    </MBox>
  );
};

export default App;
